import React from "react";
import "./ListSection.css";

const ListSection = ({ title, items }) => {
  return (
    <div className="list-section">
      {title && <h2 className="section-title">{title}</h2>}
      <div className="list-items">
        {items.sort((a, b) => b.start - a.start).map((item, index) => (
          <p key={index}>
            ks. {item.priest} ({item.start})
          </p>
        ))}
      </div>
    </div>
  );
};

export default ListSection;
